import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import AriesTable from '../../components_2/AriesTable';
import TaskListHeaderAries from './TaskListHeaderAries';
import TaskListRowAries from './TaskListRowAries';

const HEADER_FIELDS = [
  { title: 'Job Id', isSortable: false, width: '10%' },
  { title: 'Site Name', isSortable: true, width: '15%' },
  { title: 'Job Type', isSortable: false, width: '13%' },
  { title: 'Job Kind', isSortable: false, width: '12%' },
  { title: 'Assigned To', isSortable: false, width: '15%' },
  { title: 'Due Date', isSortable: true, width: '12%' },
  { title: 'Status', isSortable: false, width: '12%' },
  { title: ' ', isSortable: false, width: '11%' },
];

const isMobileWidth = () =>
  globalThis.window !== undefined && globalThis.window.innerWidth <= 767;

const TaskListLayout = ({
  setSearchText,
  setFilters,
  handleSearch,
  reportType,
  setDatePeriod,
  setReportType,
  sortData,
  jobList,
  loadMore,
  isfetching,
  hasMoreItems,
  endMessage,
  isEndMessageVisible,
  searchText,
  isCrossVisible,
  reportCategories,
  handleStartJob,
  printPage,
  viewMode,
  setViewMode,
}) => {
  const [isMobile, setIsMobile] = useState(isMobileWidth());

  useEffect(() => {
    const handleResize = () => setIsMobile(isMobileWidth());
    globalThis.window.addEventListener('resize', handleResize);
    return () => globalThis.window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="aries-jobs-due">
      <TaskListHeaderAries
        searchText={searchText}
        isCrossVisible={isCrossVisible}
        setSearchText={setSearchText}
        handleSearch={handleSearch}
        reportType={reportType}
        setReportType={setReportType}
        setFilters={setFilters}
        setDatePeriod={setDatePeriod}
        printPage={printPage}
        reportCategories={reportCategories}
        minDate={moment(new Date())}
        viewMode={viewMode}
        setViewMode={setViewMode}
      />
      <div className="aries-cards">
        <AriesTable
          headerData={HEADER_FIELDS}
          bodyData={jobList}
          RowToRender={TaskListRowAries}
          RowToRenderProps={{ handleStartJob }}
          sortData={sortData}
          loadMore={loadMore}
          hasMoreItems={hasMoreItems}
          isLoaderVisible={isfetching}
          isEndMessageVisible={isEndMessageVisible}
          endMessage={endMessage}
          height={isMobile ? null : 'fill'}
        />
      </div>
    </div>
  );
};

TaskListLayout.propTypes = {
  setSearchText: PropTypes.func,
  setFilters: PropTypes.func,
  isCrossVisible: PropTypes.bool,
  handleSearch: PropTypes.func,
  printPage: PropTypes.func,
  reportType: PropTypes.string,
  setDatePeriod: PropTypes.func,
  setReportType: PropTypes.func,
  sortData: PropTypes.func,
  jobList: PropTypes.array,
  loadMore: PropTypes.func,
  isfetching: PropTypes.bool,
  hasMoreItems: PropTypes.bool,
  endMessage: PropTypes.string,
  isEndMessageVisible: PropTypes.bool,
  searchText: PropTypes.string,
  reportCategories: PropTypes.object,
  handleStartJob: PropTypes.func,
  viewMode: PropTypes.string,
  setViewMode: PropTypes.func,
};

export default TaskListLayout;
